// extracted by mini-css-extract-plugin
export default {"list":"SelectData_list__Ltuk-","item":"SelectData_item__wW6ZQ","selected":"SelectData_selected__GTxT8","label":"SelectData_label__pjsnO","count":"SelectData_count__IaoxI"};